module.exports = __webpack_public_path__ + "img/p-djl-clark.90693d94.png";